(function() {
    'use strict';

    angular
        .module('app.contratos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/contratos',
                config: {
                    templateUrl: 'app/contratos/list.html',
                    controller: 'contratos.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-contrato/:id?',
                config: {
                    templateUrl: 'app/contratos/edit.html',
                    controller: 'contratos.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/editar-contrato-detalle/:contrato?/:id?',
                config: {
                    templateUrl: 'app/contratos/edit-detail.html',
                    controller: 'contratos.EditDetalle',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
